import { AuthenticationService } from "../../authenticationService";
import { APIService } from "../../apiService";

export interface HmrcExchangeRate {
  id: string;
  currencyCode: string;
  currencyName: string;
  countryTerritory: string;
  rateToGBP: number;
  startDate: string;
  endDate: string;
  monthYear?: string;
  createdAt?: string;
}

export interface GetHmrcExchangeRatesResponse {
  items: HmrcExchangeRate[];
}

class HmrcExchangeRateAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/finance/hmrc-exchange-rates");
  }

  async getHmrcExchangeRates(): Promise<GetHmrcExchangeRatesResponse> {
    return await this.jwtRequest("GET");
  }
}

export { HmrcExchangeRateAPIService };
